import React, { Component } from "react";
import { GET_ALL_INSURERS } from "../../../configs/api-paths";
import { fetchProtectedResource } from "../../../utilities";

class SelectInsurer extends Component {
	state = {
		insurers: [],
	};

	componentDidMount() {
		this.getInsurers();
	}

	getInsurers = async () => {
		const result = await fetchProtectedResource(GET_ALL_INSURERS);
		this.setState({
			insurers: await result.json(),
		});
	};

	onChangeSelected = (e) => {
		this.props.onChangeSelected(e.target.value);
	};

	render() {
		const { insurers } = this.state;
		return (
			<select onChange={this.onChangeSelected} defaultValue={"DEFAULT"}>
				<option value="DEFAULT" disabled>
					Choose insurer to upload a new rate file
				</option>
				{insurers.map((insurer, index) => {
					return (
						<option key={index} value={insurer.id}>
							{insurer.name}
						</option>
					);
				})}
			</select>
		);
	}
}

export default SelectInsurer;
